<template>
   <div class="More-text">
   <router-link :to="to">{{$t("pages.pricing.learnMore.learnMore")}}&nbsp;&rarr;</router-link>
   </div>
</template>

<script>
    export default {
        name: "PlayerProductReadMoreButton",
        props:["to"]
    }
</script>

<style scoped lang="scss">
   @import "../../../theme/theme";
   a {
      text-decoration: none;
      color: $primary20;
      font-size: 1rem;
      font-weight: 300;
   }
   a:hover {
      text-decoration: none;
      color: $primary80;
   }
</style>